import { ConsoleButton } from 'game/components/ConsoleButton';
import { Message, message } from 'game/components/Message';
import { createStyles } from 'game/lib/createStyles';
import { BotState } from 'game/state/BotState';

const classes = createStyles({
  row: {
    display: 'flex',
    '& > * + *': {
      marginLeft: 10,
    },
  },
});

interface BotConfigProps {
  adding: boolean,
  setAdding: (adding: boolean) => void,
  helping: boolean,
  setHelping: (helping: boolean) => void,
  bot: BotState,
}

export const BotConfig: React.FC<BotConfigProps> = ({
  adding,
  setAdding,
  helping,
  setHelping,
  bot,
}) => {
  return (
    <div className={classes.row}>
      <div>
        <ConsoleButton
          variant="hi-vis"
          active={adding}
          onClick={() => setAdding(!adding)}
        >
          <Message text="Add module (Q)" />
        </ConsoleButton>
      </div>
      <div>
        <ConsoleButton
          active={bot.running}
          onClick={() => { bot.running = true; }}
          title={message('Play')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" height="42" width="42">
            <path fill="#61a32c" d="M16 37.85v-28l22 14Zm3-14Zm0 8.55 13.45-8.55L19 15.3Z" />
          </svg>
        </ConsoleButton>
      </div>
      <div>
        <ConsoleButton
          active={!bot.running}
          onClick={() => { bot.running = false; }}
          title={message('Stop')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" height="42" width="42">
            <path fill="#c1272d" d="M15 15v18Zm-3 21V12h24v24Zm3-3h18V15H15Z" />
          </svg>
        </ConsoleButton>
      </div>
      <div>
        <ConsoleButton
          active={bot.looping}
          onClick={() => { bot.looping = !bot.looping; }}
          title={message('Loop')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" height="32" width="32">
            <path d="m14 44-8-8 8-8 2.1 2.2-4.3 4.3H35v-8h3v11H11.8l4.3 4.3Zm-4-22.5v-11h26.2l-4.3-4.3L34 4l8 8-8 8-2.1-2.2 4.3-4.3H13v8Z" />
          </svg>
        </ConsoleButton>
      </div>
      <div>
        <ConsoleButton
          active={helping}
          onClick={() => { setHelping(!helping); }}
          title={message('Help')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" height="32" width="32">
            <path fill="#0071bc" d="M24.2 35.65q.8 0 1.35-.55t.55-1.35q0-.8-.55-1.35t-1.35-.55q-.8 0-1.35.55t-.55 1.35q0 .8.55 1.35t1.35.55Zm-1.75-7.3h2.95q0-1.3.325-2.375T27.75 23.5q1.55-1.3 2.2-2.55.65-1.25.65-2.75 0-2.65-1.725-4.25t-4.575-1.6q-2.45 0-4.325 1.225T17.25 16.95l2.65 1q.55-1.4 1.65-2.175 1.1-.775 2.6-.775 1.7 0 2.75.925t1.05 2.375q0 1.1-.65 2.075-.65.975-1.9 2.025-1.5 1.3-2.225 2.575-.725 1.275-.725 3.375ZM24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Zm0-3q7.1 0 12.05-4.975Q41 31.05 41 24q0-7.1-4.95-12.05Q31.1 7 24 7q-7.05 0-12.025 4.95Q7 16.9 7 24q0 7.05 4.975 12.025Q16.95 41 24 41Zm0-17Z" />
          </svg>
        </ConsoleButton>
      </div>
    </div>
  );
};
